import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { Switch } from "@mantine/core";
/** SDS toggle switch built on Mantine; on/off/disabled styling comes from the app-wide theme. */
export function FormSwitch(props) {
  return /*#__PURE__*/React.createElement(Switch, _extends({
    size: "md"
  }, props));
}